<template>
  <v-app>
    <v-main>
      <!-- <Home/> -->
      <router-view></router-view>
      <!-- <v-container fill-height>
        <v-row wrap style="height: 100%;">
          <v-col cols=2>
            <home/>
          </v-col>
          <v-col cols=9>
            <v-card>
              ll
            </v-card>
          </v-col>
        </v-row>
      </v-container> -->
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';
import Home from './views/Home'

export default {
    name: 'App',

    components: {
        HelloWorld,
        Home
    },

    data: () => ({
        //
    }),
};
</script>

<style>
#title_card {
    /* border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px; */
    -webkit-box-shadow: 0 30px 50px rgba(0, 0, 0, .2);
    box-shadow: 0 5px 10px rgba(0, 0, 0, .2);
}
</style>
